import type { PredictionRunStatus } from "../model/reducer";
import { privateStorage } from "@/lib/privateStorage";
import type { PredictionRequest } from "../model/types";

export const DRAFT_STORAGE_KEY = "oransim_v3_prediction_draft";

export function isPredictionRouteReloadSafe(
  draft: PredictionRequest | null,
  runStatus: PredictionRunStatus,
): boolean {
  if (runStatus === "submitting" || runStatus === "running") return false;
  try {
    const stored = privateStorage.getItem(DRAFT_STORAGE_KEY);
    if (draft === null) return stored === null;
    return stored === JSON.stringify(draft);
  } catch {
    return false;
  }
}
